import { colors } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, responsiveFontSize, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { getIconPath } from 'src/utils';

const CHECK_MARK_ICON = getIconPath('icons-16-checkmark.svg');

const { spacing, text } = theme;

export const wrapper = css`
  display: grid;
  grid-template-columns: ${pxToRem(32)} 1fr;
  margin: ${stack(spacing.xs)};
  padding: ${pxToRem(8)};
  border-radius: ${pxToRem(10)};
  border: solid 1px ${colors.neutralLight};
  transition: border-color 0.15s ease-in, background-color 0.15s ease-in;

  &:hover {
    border-color: ${colors.neutralDark};
  }

  &[data-is-selected='true'] {
    box-shadow: 0 0 ${pxToRem(8)} 0 rgba(0, 0, 0, 0.2);
    border-color: ${colors.brandBluePrimary};
  }
`;

export const label = css`
  display: grid;
  grid-template-columns: 2fr 1fr;
  ${responsiveFontSize(text.xxs)};
  margin-left: ${pxToRem(spacing.xs)};
  padding: ${pxToRem(6)} ${pxToRem(4)} ${pxToRem(6)} 0;
  position: relative;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: ${pxToRem(-8)};
    width: calc(100% + ${pxToRem(10)});
    height: calc(100% + ${pxToRem(spacing.md)});
  }
`;

export const priceModifier = css`
  justify-self: flex-end;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const priceOperator = css`
  font-size: ${pxToRem(text.xs.SMALL.fontSize)};
  justify-self: flex-end;
  margin-right: ${pxToRem(2)};

  &[data-is-negative='false'] {
    font-size: ${pxToRem(text.md.SMALL.fontSize)};
  }
`;

export const radioDial = css`
  &:checked::before {
    border: none;
    background: url(${CHECK_MARK_ICON}) 50% 50% no-repeat;
    background-color: transparent;
  }

  &:checked:after {
    transition: background-color 500ms;
    background-color: transparent;
  }
`;
